import { createFileRoute } from '@tanstack/react-router';
import { SettingsHubPage } from '@/features/tenant/pages/settings-hub-page';

export const Route = createFileRoute('/_app/settings/')({ component: SettingsHubPage });
